// The structured 422 for a hiring-goal designation or seat-capacity refusal.

// Mirrored against HiringGoals::RendersDesignationRefusal::ERROR_TYPE in
// apps/hire through tools/contract-mirrors/mirrors.json.
export const HIRING_GOAL_REQUIRED_ERROR_TYPE = 'hiring_goal_required';

export const HIRING_GOAL_REQUIRED_REASONS = [
  'choice_required',
  'goal_filled',
  'no_open_seat',
  'short_of_seats',
  'goals_full',
  'no_goal',
  'short_of_room',
] as const;

export interface HiringGoalRequirement {
  reason: (typeof HIRING_GOAL_REQUIRED_REASONS)[number];
  funnel_id: string | null; // eslint-disable-line camelcase
  blocked_applicants: Array<{ id: string; name: string | null }>; // eslint-disable-line camelcase
  hiring_goals: Array<{ id: string; goal: number; hires_count: number }>; // eslint-disable-line camelcase
}

// What the axios interceptor rejects with when the response body carries
// `error_type: 'hiring_goal_required'`.
export interface HiringGoalRequiredRejection {
  errorType: typeof HIRING_GOAL_REQUIRED_ERROR_TYPE;
  message: string;
  hiringGoalRequirement: HiringGoalRequirement | null;
}

export function isHiringGoalRequiredRejection(
  value: unknown,
): value is HiringGoalRequiredRejection {
  if (value == null || typeof value !== 'object') {
    return false;
  }
  const candidate = value as { errorType?: unknown; message?: unknown };
  return (
    candidate.errorType === HIRING_GOAL_REQUIRED_ERROR_TYPE &&
    typeof candidate.message === 'string'
  );
}
